module.exports = __webpack_public_path__ + "static/media/CCBMobileNav.a09a2c9a.png";